import Service from '@/service/index.js';
import QRCode from 'qrcodejs2';

export default {
  props: ['qrCodeVisible', 'projectId', 'projectType'],
  data() {
    return {
    };
  },
  computed: {
    dialogVisiable: {
      get () {
        return this.qrCodeVisible;
      },
      set (val) {
        console.log(val);
        this.$emit('update:qrCodeVisible', val);
      }
    }
  },
  mounted() {
    this.$nextTick().then(() => {
      this.generateSignQrCode();
    });
  },
  methods: {
    // 生成二维码
    generateSignQrCode() {
      let params = {
        projectId: this.projectId,
        projectType: this.projectType
      };
      Service.generateSignQrCode(params).then(res => {
        if(res.code === '0') {
          document.getElementById('qrCodeImg').innerHTML = '';
          // 协议类型 + 地址 + 接口、参数
          let httpUrl = window.location.protocol + '//' + window.location.host + res.data;

          new QRCode(this.$refs.qrCodeImg, {
            text: httpUrl,
            width: 200,
            height: 200,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
          });
        }
      });
    }
  }
};
